import { render, staticRenderFns } from "./RCCourse.vue?vue&type=template&id=664b3943&scoped=true"
import script from "./RCCourse.vue?vue&type=script&lang=js"
export * from "./RCCourse.vue?vue&type=script&lang=js"
import style0 from "./RCCourse.vue?vue&type=style&index=0&id=664b3943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b3943",
  null
  
)

export default component.exports